import apiClient from "./client";
import type {
  GetStatusMapParams,
  StatusMapResponse,
} from "../types/status-map";

export const getStatusMap = async (
  params: GetStatusMapParams
): Promise<StatusMapResponse> => {
  const { data } = await apiClient.get<StatusMapResponse>("/status-map", {
    params: {
      disaster_id: params.disaster_id,
      ne_lat: params.ne_lat,
      sw_lat: params.sw_lat,
      ne_lng: params.ne_lng,
      sw_lng: params.sw_lng,
      damage_only: params.damage_only,
      limit: params.limit,
    },
  });
  return data;
};
